// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router'
import './assets/common.css'
import VueWechatTitle from 'vue-wechat-title'
import Vant from 'vant';
import 'vant/lib/index.css';
import {
  GetItem
} from "@/services/getData.js";

var VueTouch = require('vue-touch')
Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(Vant);
Vue.use(Vuex);
Vue.use(VueWechatTitle);
Vue.config.productionTip = false

//全局路由
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if(from.name=='error')
  {
    router.push({ name: 'error' });
  }
  if (to.name == 'home' || to.name == 'navigation'||to.name=='error') {
    next();
  }
  else {
    if (GetItem('openid')) {
      if (GetItem('openid') != 0) {
        next();
      } else {
        router.push({ name: 'error' });
      }

    }
    else {
      router.push({ name: 'error' });
    }
  }
})

// 添加Vuex状态管理的自定义插件saveStoreToLocalStorage
// 会在每次执行了mutation后调用插件保存state到localStorage中
const saveStoreToLocalStorage = store => {
  store.subscribe((mutation, state) => {
    localStorage.setItem('APPSTATE', JSON.stringify(state));
  });
}
const LocalState = JSON.parse(localStorage.getItem('APPSTATE'));
const store = new Vuex.Store({
  state: LocalState || {
    userInfo: {}
  },

  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = payload;
    }
  },
  plugins: [saveStoreToLocalStorage]
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js